import React, { Component } from 'react';
import { staticImages } from '../../assets/static-images';

class NavigationArrow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selected: false
		};

		this.arrows = {
			back: {
				default: staticImages.itemArrowLeft,
				selected: staticImages.itemArrowLeftSelected
			},
			next: {
				default: staticImages.itemArrowRight,
				selected: staticImages.itemArrowRightSelected
			},
			begin_back: {
				default: staticImages.beginArrowLeft,
				selected: staticImages.beginArrowLeftSelected
			},
			begin_next: {
				default: staticImages.beginArrowRight,
				selected: staticImages.beginArrowRightSelected
			},
			end_back: {
				default: staticImages.endArrowLeft,
				selected: staticImages.endArrowLeftSelected
			},
			end_next: {
				default: staticImages.endArrowRight,
				selected: staticImages.endArrowRightSelected
			}
		}
	}

	render() {
		const { type, onClick } = this.props;
		const { selected } = this.state;
		let width = 70;
		let height = 52;

		if (type.includes('begin_')) {
			width = 110;
			height = 76;
		} else if (type.includes('end_')) {
			width = 123;
			height = 85;
		}

		return (
			<button
				className="navigation-button"
				onMouseEnter={() => this.setState({ selected: true })}
				onMouseLeave={() => this.setState({ selected: false })}
				onClick={onClick}>
				<img {...{width, height}} src={this.arrows[type][selected ? 'selected' : 'default']} alt={type} />
			</button>
		);
	}
}

export default NavigationArrow;
